import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import { LatencyCard, LatencyTooltip } from './LatencyCard';
import { CHART_STYLES } from '../../Dashboard/constants/chartStyles';
import type { FallbacksResponse } from '../../../../../api';

type Props = {
  data?: FallbacksResponse | null;
  loading?: boolean;
};

export const FallbacksCard: React.FC<Props> = ({ data, loading }) => {
  const chartData = (data?.items ?? [])
    .map(item => ({
      name: item.failed_model || item.component || 'unknown',
      value: item.count,
    }))
    .slice(0, 12);

  return (
    <LatencyCard
      title="Fallbacks by failed model"
      subtitle="count of provider/model fallbacks"
      loading={loading}
      isEmpty={chartData.length === 0}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 10, right: 20, left: 0, bottom: 20 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke={CHART_STYLES.COLORS.GRID}
          />
          <XAxis
            dataKey="name"
            stroke={CHART_STYLES.COLORS.AXIS}
            fontSize={11}
            tickLine={false}
            axisLine={false}
            angle={-20}
            textAnchor="end"
            height={50}
          />
          <YAxis
            stroke={CHART_STYLES.COLORS.AXIS}
            fontSize={12}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
            width={40}
          />
          <Tooltip
            cursor={{ fill: 'rgba(136,132,216,0.06)' }}
            isAnimationActive={false}
            content={<LatencyTooltip />}
          />
          <Bar
            dataKey="value"
            name="fallbacks"
            fill={CHART_STYLES.COLORS.PRIMARY}
            radius={[CHART_STYLES.RADIUS.BAR, CHART_STYLES.RADIUS.BAR, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </LatencyCard>
  );
};
